var cov_21gpgdfjoo = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/Jumper.tsx",
      hash = "f6e6a0101e313342739dfc14f9e3af56fd5c45d0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/Jumper.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 19
        },
        end: {
          line: 8,
          column: 57
        }
      },
      "1": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 16
        }
      },
      "3": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 54
        }
      },
      "4": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 36
        }
      },
      "5": {
        start: {
          line: 24,
          column: 32
        },
        end: {
          line: 24,
          column: 42
        }
      },
      "6": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 43
        }
      },
      "7": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "8": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 70
        }
      },
      "9": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 27
        }
      },
      "10": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 43
        }
      },
      "11": {
        start: {
          line: 33,
          column: 37
        },
        end: {
          line: 33,
          column: 43
        }
      },
      "12": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "13": {
        start: {
          line: 34,
          column: 23
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "14": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 38
        }
      },
      "15": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 31
        }
      },
      "16": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "17": {
        start: {
          line: 38,
          column: 25
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "18": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "19": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 26
        }
      },
      "20": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 34
        }
      },
      "21": {
        start: {
          line: 48,
          column: 46
        },
        end: {
          line: 48,
          column: 56
        }
      },
      "22": {
        start: {
          line: 50,
          column: 44
        },
        end: {
          line: 50,
          column: 91
        }
      },
      "23": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "24": {
        start: {
          line: 52,
          column: 24
        },
        end: {
          line: 52,
          column: 54
        }
      },
      "25": {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "26": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 83,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 15
          },
          end: {
            line: 9,
            column: 16
          }
        },
        loc: {
          start: {
            line: 9,
            column: 21
          },
          end: {
            line: 9,
            column: 23
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 34
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 23,
            column: 11
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 58
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 28
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 47
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 38
          }
        }, {
          start: {
            line: 25,
            column: 42
          },
          end: {
            line: 25,
            column: 43
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 43
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 43
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 34
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 34
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 38
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 38
          }
        }],
        line: 38
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 44
          },
          end: {
            line: 50,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 58
          },
          end: {
            line: 50,
            column: 86
          }
        }, {
          start: {
            line: 50,
            column: 89
          },
          end: {
            line: 50,
            column: 91
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        }],
        line: 51
      },
      "8": {
        loc: {
          start: {
            line: 67,
            column: 9
          },
          end: {
            line: 67,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 18
          },
          end: {
            line: 67,
            column: 39
          }
        }, {
          start: {
            line: 67,
            column: 42
          },
          end: {
            line: 67,
            column: 51
          }
        }],
        line: 67
      },
      "9": {
        loc: {
          start: {
            line: 78,
            column: 37
          },
          end: {
            line: 78,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 37
          },
          end: {
            line: 78,
            column: 45
          }
        }, {
          start: {
            line: 78,
            column: 49
          },
          end: {
            line: 78,
            column: 63
          }
        }],
        line: 78
      },
      "10": {
        loc: {
          start: {
            line: 81,
            column: 9
          },
          end: {
            line: 81,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 18
          },
          end: {
            line: 81,
            column: 39
          }
        }, {
          start: {
            line: 81,
            column: 42
          },
          end: {
            line: 81,
            column: 51
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/Jumper.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { getUidStr } from '../utils/uid';
import { paginationClass } from './styles';
import Input from '../Input';
import { getDirectionClass } from '../utils/classname';
var inputStyle = (cov_21gpgdfjoo.s[0]++, {
  width: 60,
  display: 'inline-block'
});
cov_21gpgdfjoo.s[1]++;

var nofunc = function nofunc() {
  cov_21gpgdfjoo.f[0]++;
};

var Jumper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Jumper, _PureComponent);

  var _super = _createSuper2(Jumper);

  function Jumper(props) {
    var _this;

    _classCallCheck(this, Jumper);

    cov_21gpgdfjoo.f[1]++;
    cov_21gpgdfjoo.s[2]++;
    _this = _super.call(this, props);
    _this.renderRequire = void 0;
    _this.autoFocus = void 0;
    cov_21gpgdfjoo.s[3]++;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    cov_21gpgdfjoo.s[4]++;
    _this.renderRequire = getUidStr();
    return _this;
  }

  _createClass(Jumper, [{
    key: "getMax",
    value: function getMax() {
      cov_21gpgdfjoo.f[2]++;

      var _ref = (cov_21gpgdfjoo.s[5]++, this.props),
          total = _ref.total,
          pageSize = _ref.pageSize;

      cov_21gpgdfjoo.s[6]++;
      return (cov_21gpgdfjoo.b[0][0]++, Math.ceil(total / pageSize)) || (cov_21gpgdfjoo.b[0][1]++, 1);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_21gpgdfjoo.f[3]++;
      cov_21gpgdfjoo.s[7]++;

      if (e.keyCode === 13) {
        cov_21gpgdfjoo.b[1][0]++;
        var current = (cov_21gpgdfjoo.s[8]++, parseInt(e.target.value, 10));
        cov_21gpgdfjoo.s[9]++;
        this.autoFocus = true;
        cov_21gpgdfjoo.s[10]++;

        if (!Number.isFinite(current)) {
          cov_21gpgdfjoo.b[2][0]++;
          cov_21gpgdfjoo.s[11]++;
          return;
        } else {
          cov_21gpgdfjoo.b[2][1]++;
        }

        cov_21gpgdfjoo.s[12]++;

        if (current < 1) {
          cov_21gpgdfjoo.b[3][0]++;
          cov_21gpgdfjoo.s[13]++;
          current = 1;
        } else {
          cov_21gpgdfjoo.b[3][1]++;
        }

        cov_21gpgdfjoo.s[14]++;
        this.renderRequire = getUidStr();
        var max = (cov_21gpgdfjoo.s[15]++, this.getMax());
        cov_21gpgdfjoo.s[16]++;

        if (current > max) {
          cov_21gpgdfjoo.b[4][0]++;
          cov_21gpgdfjoo.s[17]++;
          current = max;
        } else {
          cov_21gpgdfjoo.b[4][1]++;
        }

        cov_21gpgdfjoo.s[18]++;

        if (current === this.props.current) {
          cov_21gpgdfjoo.b[5][0]++;
          cov_21gpgdfjoo.s[19]++;
          this.forceUpdate();
        } else {
          cov_21gpgdfjoo.b[5][1]++;
        }

        cov_21gpgdfjoo.s[20]++;
        this.props.onChange(current);
      } else {
        cov_21gpgdfjoo.b[1][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_21gpgdfjoo.f[4]++;

      var _ref2 = (cov_21gpgdfjoo.s[21]++, this.props),
          current = _ref2.current,
          text = _ref2.text,
          size = _ref2.size,
          isSimple = _ref2.isSimple;

      var txt = (cov_21gpgdfjoo.s[22]++, text.jumper ? (cov_21gpgdfjoo.b[6][0]++, text.jumper.split('{input}')) : (cov_21gpgdfjoo.b[6][1]++, []));
      cov_21gpgdfjoo.s[23]++;

      if (isSimple) {
        cov_21gpgdfjoo.b[7][0]++;
        var spanClass = (cov_21gpgdfjoo.s[24]++, paginationClass('simple-span'));
        cov_21gpgdfjoo.s[25]++;
        txt = [[], [
        /*#__PURE__*/
        React.createElement("span", {
          key: "separator",
          className: spanClass,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 11
          }
        }, "/"),
        /*#__PURE__*/
        React.createElement("span", {
          key: "pageMax",
          className: spanClass,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59,
            columnNumber: 11
          }
        }, this.getMax())]];
      } else {
        cov_21gpgdfjoo.b[7][1]++;
      }

      cov_21gpgdfjoo.s[26]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: paginationClass(getDirectionClass('section')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66,
            columnNumber: 7
          }
        }, txt[0] ? (cov_21gpgdfjoo.b[8][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 67,
            columnNumber: 19
          }
        }, txt[0])) : (cov_21gpgdfjoo.b[8][1]++, undefined),
        /*#__PURE__*/
        React.createElement(Input, {
          key: this.renderRequire,
          value: String(current),
          onChange: nofunc,
          autoFocus: this.autoFocus,
          onKeyDown: this.handleKeyDown,
          digits: 0,
          type: "number",
          style: inputStyle,
          size: size,
          className: paginationClass((cov_21gpgdfjoo.b[9][0]++, isSimple) && (cov_21gpgdfjoo.b[9][1]++, 'simple-input')),
          delay: 400,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 68,
            columnNumber: 9
          }
        }), txt[1] ? (cov_21gpgdfjoo.b[10][0]++,
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 19
          }
        }, txt[1])) : (cov_21gpgdfjoo.b[10][1]++, undefined))
      );
    }
  }]);

  return Jumper;
}(PureComponent);

export default Jumper;